
































import { defineComponent } from '@vue/composition-api'
import { PropType } from 'vue';
import { COLLAGES, SHOW_TYPES } from '~/utils/constants/solepro/cms';
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';
import { BannerType, SlideType } from '~/types/solepro/PageBuilder';
import { rgbaToHex } from '~/utils/solepro/functions';
import VideoBackground from '~/mixins/solepro/VideoBackground.vue';
import { trackPageBuilderButton } from '~/helpers/trackings/24orepro/components';

export default defineComponent({
    mixins: [PageBuilderComponent, VideoBackground],
    props: {
        node: {
            type: Object as PropType<SlideType>,
            required: true
        }
    },
    setup(props) {
        const { node: content } = props as Readonly<{ node: BannerType }>;
        const isTrack = !!content.soleProfessionistiTrack;
        const isLink = !!content.bannerDatas.link;
        const isTargetBlank = content?.bannerDatas?.linkTargetBlank ? '_blank' : null;

        const trackFunction = (e) => {
            e.preventDefault();
            trackPageBuilderButton(content.soleProfessionistiTrack, content.bannerDatas.link ?? '', isTargetBlank);
        }
        
        const trackSlide = (e) => isTrack && isLink ? trackFunction(e) : null;

        /**
         * Managinganage video
         */

        /**
         * Managing banner link
         */
        const ComponentWrapper = isLink ? {
            component: () => import('~/components/solepro/Link.vue'),
            href: content.bannerDatas.link,
            target: content.bannerDatas.linkTargetBlank ? '_blank' : null,
            ariaLabel: content.bannerDatas.alt,
            title: content.bannerDatas.title,
            track: isLink && isTrack ? trackSlide : null
        } : { component: 'div' }

        const overlay = content.bannerDatas.contentOverlay;
        const overlayColor = rgbaToHex(overlay.overlayColor);
        const overlayBg = `bg-[${overlayColor.color}]/[.${overlayColor.opacityPercentage}]`;
        let overlayClassesArr = ['flex', 'items-center', 'w-fit'];
        let innerClasses = '';
        switch (overlay.showType) {
            case SHOW_TYPES.ALWAYS: innerClasses += ` ${overlayBg}`; break;
            case SHOW_TYPES.HOVER: innerClasses += `group-hover:${overlayBg}`; break;
        }
        const maxOverlayWidth = 'max-w-[540px]'
        switch (content.appearance) {
            case COLLAGES.RIGHT: overlayClassesArr.push(`justify-end`); innerClasses += ` w-full ${maxOverlayWidth}`; break;
            case COLLAGES.LEFT: overlayClassesArr.push(`justify-start`); innerClasses += ` w-full ${maxOverlayWidth}`; break;
            case COLLAGES.CENTER: overlayClassesArr.push(`justify-center`); innerClasses += ` w-full ${maxOverlayWidth}`; break;
            case COLLAGES.POSTER: innerClasses += ' w-full min-h-[inherit] flex flex-col justify-center '; break;
        }

        const hasButton = content.showButton == SHOW_TYPES.ALWAYS || content.showButton == SHOW_TYPES.HOVER;
        let buttonClasses = '';
        switch (content.showButton) {
            case SHOW_TYPES.NEVER: buttonClasses = 'invisible pointer-events-none'; break;
            case SHOW_TYPES.HOVER: buttonClasses += ' invisible pointer-events-none group-hover:visible group-hover:pointer-events-auto'; break;
        }

        return {
            content,
            ComponentWrapper,
            overlayClasses: (overlayClassesArr || []).join(' '),
            innerClasses,
            hasIframe :content.bannerDatas.videoSrc && !content.bannerDatas.videoSrc.endsWith('.mp4'),
            bannerText: content.content.text,
            hasButton,
            buttonClasses,
        }
    },
})
